import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'
import { SectionHeader } from '@factorialco/f0-react/dist/experimental'
import i18n from 'modules/core/lib/i18n'

const capitalize = (str: string) => str.charAt(0).toUpperCase() + str.slice(1)

export interface DeviceAttribute {
  id: string
  name: string
  value: string
}

export interface DeviceSpecificationsProps {
  attributes: DeviceAttribute[]
}

export const DeviceSpecifications: React.FC<DeviceSpecificationsProps> = ({ attributes }) => {
  if (!attributes || attributes.length === 0) {
    return null
  }

  return (
    <Box gap="s16" flexDirection="column" paddingY="s16">
      <SectionHeader
        title={i18n.t('it_management.device_catalog.detail.technical_specifications')}
        description={''}
      />
      <Box flexDirection="column" gap="s24" flexWrap="wrap">
        {attributes.map((attribute: DeviceAttribute) => (
          <Box key={attribute.id} flexDirection="column" gap="s4">
            <Text size="200" weight="medium" color="grey700">
              {capitalize(attribute.name)}
            </Text>
            <Text size="300" weight="normal" color="black">
              {attribute.value}
            </Text>
          </Box>
        ))}
      </Box>
    </Box>
  )
}
